<template>
  <div>
    <CRow>
      <CCol col="12" >
        <CRow>
          <CCol>
            <CCard>
              <CCardBody>
                <CInput v-model="os"/>
                {{os}}
                <CRow>
                  <CCol>
                    <MultiLanguage caption="Title" :items="content.title" />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <MultiLanguage caption="Title" :items="content.message" />
                  </CCol>
                </CRow>
                <CRow>
                  <CCol>
                    <MLEditor caption="Description" :items="content.description" />
                  </CCol>
                </CRow>

                <CRow>
                  <CCol  class="text-right">
                    <CButton color="success" class="px-4" @click="onSave">{{(content._id == null?"CREATE":"UPDATE")}}</CButton>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
  </div>
</template>

<script>

import Vue from 'vue'
import {mapGetters} from 'vuex'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import SearchEduction from "@/projects/components/Util/SearchEduction";
import MultiLanguage from "@/projects/components/Util/MultiLanguage";
import MLEditor from "@/projects/components/Util/MLEditor";
Vue.use(VueQuillEditor)

export default {
  name: 'FMethod',
  components: {MLEditor, MultiLanguage, SearchEduction},
  props: {
    // items: Array,
    // fields: {
    //   type: Array,
    //   default () {
    //     return [
    //       { key: 'no',label:'No'},
    //       { key: 'startDate',label:'StartDate'},
    //       { key: 'endDate',label:'EndDate'},
    //       { key: '#',label:'#' },
    //
    //     ]
    //   }
    // },
    caption: {
      type: String,
      default: 'User Accounts'
    },
    disable: {
      type: Boolean,
      default: false
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },

  data: function () {
    return {
      horizontal: { label:'col-3', input:'col-9' },
      os:"",
      content : {
        _id : null,
        title : [{key:"th", value:""},{key:"en", value:""}],
        message : [{key:"th", value:""},{key:"en", value:""}],
        description : [{key:"th", value:""},{key:"en", value:""}],
      },
    }

  },

  mounted () {
  },

  created () {
    this.onInit()
  },

  beforeDestroy () {

  },

  methods: {
    onInit(){

    },

    onSave(){
    }


  },

  computed:{
    ...mapGetters({
      lang : "setting/lang",
    })
  },

  watch: {

  }

}
</script>
<style>

</style>
